import React from "react";
import { $t } from "~/i18n.js";

import {
  ContactsOutlined,
  MailOutlined,
  MessageOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import { Button, Divider, Modal, Space } from "antd";

import { SluitButton } from "../buttons/SluitButton.jsx";
import { CountryLabel } from "../form/CountryCodeSelect.jsx";
import { Icon, nood } from "../icon/icon.jsx";
import { downloadVCard, Phone, toE164 } from "./phone.jsx";

export const ContactModal = ({ pilot, gegevens, visible, onCancel, club }) => {
  const clubName = club?.full_name;
  const number = pilot?.phone;
  const country = gegevens?.country;
  const e164 = toE164(number, country);

  return (
    <Modal
      title={$t("Contactgegevens")}
      open={visible}
      onCancel={onCancel}
      footer={[<SluitButton key="sluit" onClick={onCancel} />]}
    >
      <Space style={{ marginBottom: 16 }}>
        <Button
          type="primary"
          icon={<MessageOutlined />}
          size="small"
          disabled={!e164}
          href={e164 ? `https://signal.me/#p/${e164}` : null}
          target="_blank"
          rel="noopener noreferrer"
        >
          Signal
        </Button>

        <Button
          icon={<PhoneOutlined />}
          size="small"
          disabled={!number || number === -1}
          href={e164 ? `tel:${e164}` : null}
          target="_blank"
        >
          {$t("Bellen")}
        </Button>

        <Button
          icon={<ContactsOutlined />}
          size="small"
          disabled={!number || number === -1}
          onClick={() => downloadVCard(pilot, number, clubName)}
        >
          {$t("Bewaar contact")}
        </Button>
      </Space>

      <div className="row">
        <Button
          type="primary"
          icon={<MailOutlined />}
          size="small"
          shape="circle"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          target="_blank"
          href={gegevens ? `mailto:${gegevens.email}` : null}
        />
        <p style={{ marginLeft: 6, marginRight: 18 }}>
          {gegevens ? gegevens.email : $t("onbekend")}
        </p>
      </div>

      {gegevens && gegevens.address1 && !gegevens.private_mode ? (
        <>
          <p>{gegevens.address1}</p>
          {gegevens.address2 && <p>{gegevens.address2}</p>}
          <p>
            {gegevens.zipcode}, {gegevens.city}
          </p>
          <p>
            <CountryLabel code={gegevens.country} />
          </p>
        </>
      ) : (
        <p>{$t("Woonadres onbekend/afgeschermd")}</p>
      )}

      <Divider />

      <p>
        <Icon icon={nood} viewBox="0 0 1124 1024" />{" "}
        {$t("Contactpersoon in geval van nood")}
      </p>

      {gegevens && gegevens.emergency_contact ? (
        <div>
          <p style={{ margin: "12px 0" }}>
            <span className="bold">{gegevens.emergency_contact}</span> (
            {gegevens.emergency_contact_relation})
          </p>
          <Phone number={gegevens.emergency_contact_phone} />
          <Button
            icon={<PhoneOutlined />}
            size="small"
            disabled={
              !gegevens.emergency_contact_phone ||
              gegevens.emergency_contact_phone === -1
            }
            href={
              gegevens.emergency_contact_phone
                ? `tel:${gegevens.emergency_contact_phone}`
                : null
            }
            target="_blank"
          >
            {$t("Bellen")}
          </Button>
        </div>
      ) : (
        <p>{$t("Onbekend")}</p>
      )}
    </Modal>
  );
};
